"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BUTTON_TEXT_SIZES = exports.BUTTON_SIZES = exports.BUTTON_VARIANTS = void 0;

/** Available button variants */
var BUTTON_VARIANTS = {
  default: {
    primaryBlack: {
      backgroundColor: "black100",
      borderColor: "black100",
      color: "white100"
    },
    primaryWhite: {
      backgroundColor: "white100",
      borderColor: "white100",
      color: "black100"
    },
    secondaryGray: {
      backgroundColor: "black10",
      borderColor: "black10",
      color: "black100"
    },
    secondaryOutline: {
      backgroundColor: "white100",
      borderColor: "black10",
      color: "black100"
    },
    noOutline: {
      backgroundColor: "transparent",
      borderColor: "transparent",
      color: "black100"
    }
  },
  focus: {
    primaryBlack: {
      backgroundColor: "black100",
      borderColor: "black100",
      color: "white100",
      textDecoration: "underline"
    },
    primaryWhite: {
      backgroundColor: "white100",
      borderColor: "white100",
      color: "black100",
      textDecoration: "underline"
    },
    secondaryGray: {
      backgroundColor: "black10",
      borderColor: "black10",
      color: "black100",
      textDecoration: "underline"
    },
    secondaryOutline: {
      backgroundColor: "white100",
      borderColor: "black10",
      color: "black100",
      textDecoration: "underline"
    },
    noOutline: {
      backgroundColor: "transparent",
      borderColor: "transparent",
      color: "black100",
      textDecoration: "underline"
    }
  },
  hover: {
    primaryBlack: {
      backgroundColor: "purple100",
      borderColor: "purple100",
      color: "white100"
    },
    primaryWhite: {
      backgroundColor: "purple100",
      borderColor: "purple100",
      color: "white100"
    },
    secondaryGray: {
      backgroundColor: "black30",
      borderColor: "black30",
      color: "black100"
    },
    secondaryOutline: {
      backgroundColor: "white100",
      borderColor: "black100",
      color: "black100"
    },
    noOutline: {
      backgroundColor: "transparent",
      borderColor: "transparent",
      color: "black100"
    }
  },
  loading: {
    primaryBlack: {
      backgroundColor: "transparent",
      borderColor: "transparent",
      color: "black100"
    },
    primaryWhite: {
      backgroundColor: "transparent",
      borderColor: "transparent",
      color: "black100"
    },
    secondaryGray: {
      backgroundColor: "transparent",
      borderColor: "transparent",
      color: "black100"
    },
    secondaryOutline: {
      backgroundColor: "transparent",
      borderColor: "transparent",
      color: "black100"
    },
    noOutline: {
      backgroundColor: "transparent",
      borderColor: "transparent",
      color: "black100"
    }
  },
  disabled: {
    primaryBlack: {
      backgroundColor: "black10",
      borderColor: "black10",
      color: "white100"
    },
    primaryWhite: {
      backgroundColor: "black10",
      borderColor: "black10",
      color: "white100"
    },
    secondaryGray: {
      backgroundColor: "black10",
      borderColor: "black10",
      color: "white100"
    },
    secondaryOutline: {
      backgroundColor: "black10",
      borderColor: "black10",
      color: "white100"
    },
    noOutline: {
      backgroundColor: "black10",
      borderColor: "black10",
      color: "white100"
    }
  }
};
/** Available button sizes */

exports.BUTTON_VARIANTS = BUTTON_VARIANTS;
var BUTTON_SIZES = {
  block: {
    small: {
      height: "26px",
      px: 1.5
    },
    medium: {
      height: "41px",
      px: 2
    },
    large: {
      height: "50px",
      px: 3
    }
  },
  inline: {
    small: {
      height: "17px",
      px: 0
    },
    medium: {
      height: "21px",
      px: 0
    },
    large: {
      height: "21px",
      px: 0
    }
  }
};
/** Text sizes associated with available button sizes */

exports.BUTTON_SIZES = BUTTON_SIZES;
var BUTTON_TEXT_SIZES = {
  small: "2",
  medium: "3t",
  large: "3t"
};
exports.BUTTON_TEXT_SIZES = BUTTON_TEXT_SIZES;
//# sourceMappingURL=tokens.js.map